import { GenericModal } from '../generic/Modal';
import { Fragment, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { SPICY_MEDIUM } from '../constants/constants';
import { connect } from 'react-redux';

let PreferencesModal = ({ spicyTags }) => {
  const [neverModalVisible, setNeverModalVisible] = useState(false);
  const [spicyLevelModalVisible, setSpicyLevelModalVisible] = useState(false);
  const [spicyLevelModalData, setSpicyLevelModalData] = useState({
    customerSpicyLevel: SPICY_MEDIUM,
    skuSpicyLevel: SPICY_MEDIUM,
  });

  useEffect(() => {
    $(window).on('show-nevers-modal', () => {
      setNeverModalVisible(true);
    });

    $(window).on('show-spicy-modal', (evt, data) => {
      setSpicyLevelModalData({
        customerSpicyLevel: data.customerSpicyLevel,
        skuSpicyLevel: data.skuSpicyLevel,
      });
      setSpicyLevelModalVisible(true);
    });
  }, []);

  return (
    <Fragment>
      <GenericModal
        title={"Setting to 'never'?"}
        description={
          'We do our best to keep our grocery shelves stocked with options for everyone. Please note that the more groceries you mark as ‘never,’ the less variety you’ll see in future deliveries.'
        }
        visible={neverModalVisible}
        noOverlayClick={true}
        closeText="GOT IT"
      />
      <GenericModal
        title={'Too Spicy?'}
        description={`Heads up! This product is considered ${
          spicyTags[spicyLevelModalData.skuSpicyLevel]['name']
        }, and your
                      heat tolerance is set to ${
                        spicyTags[spicyLevelModalData.customerSpicyLevel][
                          'name'
                        ]
                      }.`}
        visible={spicyLevelModalVisible}
        noOverlayClick={true}
        closeText="GOT IT"
        onClose={() => setSpicyLevelModalVisible(false)}
      />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    spicyTags: state.spicyTags,
  };
};

PreferencesModal = connect(mapStateToProps, null)(PreferencesModal);

const PreferenceModalInPortal = () => {
  return ReactDOM.createPortal(
    <PreferencesModal />,
    document.getElementById('fp-preferences-modal')
  );
};

export default PreferenceModalInPortal;
